import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import { trackHeapEvent } from 'utils/analytics';
import { IconFax } from './icons';
import s from '../s.module.less';

// fax 不是增值推销：payer 要有 fax 才能给 provider 入组，之后授权、病历索取、RFI、remit 也走它。
// 所以缺 fax 时它自成一张白底卡（不抢主操作），有 fax 就整卡不出现。
export default function FaxCard() {
    const navigate = useNavigate();
    return (
        <div className={s.faxCard}>
            <span className={s.faxIconTile}>
                <IconFax />
            </span>
            <div className={s.faxBody}>
                <div className={s.faxTitle}>Add a fax number</div>
                <div className={s.faxDesc}>
                    Payers need one on file for authorizations, records requests, and remits. Use your own, or set up
                    Klarity eFax for <b>$9.90/month</b> with 250 pages included.
                </div>
            </div>
            <Button
                className={s.outlineBtn}
                onClick={() => {
                    trackHeapEvent('WebApp - PPA Credentialing Submitted - Click - Set Up Fax', {});
                    navigate(`${PATH.DASHBOARD}/${PATH.EFAX}`);
                }}
            >
                Set up
            </Button>
        </div>
    );
}
